<template>
  <img :src="this.firstImageUrl"
       :srcset="srcSet"
       onload="if(!(width=this.getBoundingClientRect().width))return;this.onload=null;this.sizes=Math.ceil(width/window.innerWidth*100)+'vw';"
  >
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    media: {
      required: true,
      type: Object,
    },

    sizes: {
      requried: true,
      type: Array,
    },

    fallback: {
      required: false,
      type: String,
      default: '',
    },

    withoutPlaceholder: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      canUseWebp: 'ui/canUseWebp',
    }),

    srcSet() {
      const images = this.sizes
          .map(size => {
            if (!this.hasImage(size)) {
              return null
            }

            const image = this.getImage(size)

            if (!image) {
              return null
            }

            return `${image.url} ${image.width}w`
          })
          .filter(image => !!image)

      return images.join(',')
    },

    firstImageUrl() {
      for (let i in this.sizes) {
        if (!this.sizes.hasOwnProperty(i)) {
          continue
        } else if (!this.hasImage(this.sizes[i])) {
          continue
        }

        return this.getImageUrl(this.sizes[i])
      }

      return this.fallback
    }
  },

  methods: {
    hasImage(type, webp = true) {
      if (!this.media || !this.media.images || !Object.keys(this.media.images).length) {
        return false
      } else if (webp && this.canUseWebp && !!this.media.images[`${type}_webp`] && !!this.media.images[`${type}_webp`].url) {
        return true
      }

      return !!this.media.images[type] && !!this.media.images[type].url
    },

    getImage(type, webp = true) {
      if (webp && this.canUseWebp) {
        return this.media.images[`${type}_webp`]
      }

      return this.media.images[type]
    },

    getImageUrl(type, webp = true) {
      const webpImage = this.getImage(type, webp)

      if (webp && !!webpImage && !!webpImage.url) {
        return webpImage.url
      }

      const image = this.getImage(type, false)

      if (!image || !image.url) {
        return ''
      }

      return image.url
    },
  },
}
</script>
